import firebase, {db, auth, fc} from './connection'

export default {
    getCoursesCategories() {
        let ref = db.collection('coursesCategories');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getCourses() {
        let ref = db.collection('courses');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    get(id) {
        let ref = db.collection('courses').doc(id);
    
        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc};
                })
                .catch(error => {
                    return error;
                });
    },

    add(model) {
        let ref = db.collection('courses');
    
        return ref.add(model)
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

}